<div id="">
  <header id="banner" role="banner">
     <nav class="site-breadcrumbs" id="breadcrumbs">
        <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
        <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
           <li class="first"><span><a routerLink="">SIRA</a></span></li>
           <li class="last"><span><a href="/sirang/datiaperti">DATI APERTI</a></span></li>
        </ul>
     </nav>
  </header>
  <div id="content">
     <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
        <span id="p_103"></span> 
        <div class="portlet-body"> </div>
     </div>
     <div class="columns-2" id="main-content" role="main">
        <div class="portlet-layout" id="aui_3_4_0_1_591">
           <div class="aui-w70 portlet-column" id="column-1">
              <div class="portlet-dropzone portlet-column-content portlet-column-content-first" id="layout-column_column-1">
                 <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_H7pGyMq5rlnM_">
                    <span id="p_56_INSTANCE_H7pGyMq5rlnM"></span> 
                    <div class="portlet-body" id="aui_3_4_0_1_590">
                       <section class="portlet" id="portlet_56_INSTANCE_H7pGyMq5rlnM">
                          <table style="width: 100%;">
                             <tbody>
                                <tr>
                                   <td>
                                      <header class="portlet-topper gradient">
                                         <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">Dati aperti</span> </h1>
                                      </header>
                                   </td>
                                </tr>
                             </tbody>
                          </table>
                          <div class="portlet-content" id="aui_3_4_0_1_589">
                             <div class=" portlet-content-container" style="" id="aui_3_4_0_1_588">
                                <div class="portlet-body" id="aui_3_4_0_1_587">
                                   <div class="journal-content-article" id="aui_3_4_0_1_586">
                                      <p>
                                        All'interno del portale SIRA è possibile accedere a numerosi dati e informazioni sulla tematica ambientale che sono di pubblico interesse. L'accesso e l'utilizzo di tali dati da parte degli utenti del portale, consente di offrire l'informazione ambientale a più livelli accessibile direttamente online.
                                      </p>
                                      <br/>
                                      <b>Dati cartografici</b>
                                      <br/><br/>
                                      <p>
                                        Accedendo alla sezione
                                      </p>
                                      <p>
                                        <a href="https://www.sardegnasira.it/group/guest/scheda-metadati">https://www.sardegnasira.it/group/guest/scheda-metadati</a>
                                      </p>
                                      <p>
                                        è possibile visualizzare ed effettuare il download di numerosi dati cartografici relativi alle tematiche ambientali. È sufficiente effettuare la ricerca per parola chiave e cliccare successivamente sul link Apri nel viewer, per visualizzare il dato, mentre è possibile cliccare sul link Servizio di download per effettuare il download dello shapefile.
                                      </p>
                                      <br/>
                                      <b>Altri dati</b>
                                      <br/><br/>
                                      <p>
                                        Di seguito è possibile accedere ad un 'ulteriore sezione contenente ulteriori dati aperti per i quali è possibile procedere con il download.
                                      </p>
                                      <p>
                                        <a href="https://www.sardegnasira.it/dati-aperti">https://www.sardegnasira.it/dati-aperti</a>
                                      </p>
                                   </div>
                                </div>
                             </div>
                          </div>
                       </section>
                    </div>
                 </div>
              </div>
           </div>
           <div class="aui-w30 portlet-column" id="column-2">
              <div class="portlet-dropzone portlet-column-content portlet-column-content-last" id="layout-column_column-2">
                 <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_RxuFFVEU5ofT_">
                    <span id="p_56_INSTANCE_RxuFFVEU5ofT"></span> 
                    <div class="portlet-body">
                    </div>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </div>
</div>